/**
 * Webinar検索の初期化
 */
export function initWebinarSearch() {
    const form = document.getElementById("userWebinarSearchForm");
    if (form === null) {
        return;
    }
    initToggleSearchConditioneButton();
    initAllCheckButton();
    initSummaryOpenButton();
}
/**
 * 詳細検索ボックス開閉
 */
function initToggleSearchConditioneButton() {
    // 開く
    const openBtn = document.getElementById("search-condition-open-btn");
    openBtn.addEventListener("click", function () {
        const openArea = document.getElementById("search-condition-open-area");
        const closeArea = document.getElementById("search-condition-close-area");
        openArea.style.display = "block";
        closeArea.style.display = "none";
        const freeWord = document.querySelector('#freeword');
        if (freeWord === null)
            return;
        freeWord.value = "";
        const allCheckEvent = document.querySelector('#all_check_event');
        if (allCheckEvent === null)
            return;
        allCheckEvent.checked = false;
        const allCheckCourse = document.querySelector('#all_check_course');
        if (allCheckCourse === null)
            return;
        allCheckCourse.checked = false;
        const allCheckType = document.querySelector('#all_check_type');
        if (allCheckType === null)
            return;
        allCheckType.checked = false;
        const venueElements = document.querySelectorAll('[id^=cond_event_]');
        if (venueElements === null)
            return;
        for (const venueElement of venueElements) {
            const venueCheckbox = venueElement;
            venueCheckbox.checked = true;
        }
        const courseElements = document.querySelectorAll('[id^=cond_course_]');
        if (courseElements === null)
            return;
        for (const courseElement of courseElements) {
            const courseCheckbox = courseElement;
            courseCheckbox.checked = true;
        }
        const otherElements = document.querySelectorAll('[id^=cond_type_]');
        if (otherElements === null)
            return;
        for (const otherElement of otherElements) {
            const otherCheckbox = otherElement;
            otherCheckbox.checked = true;
        }
    }, false);
    // 閉じる
    const closeBtn = document.getElementById("search-condition-close-btn");
    closeBtn.addEventListener("click", function () {
        const openArea = document.getElementById("search-condition-open-area");
        const closeArea = document.getElementById("search-condition-close-area");
        openArea.style.display = "none";
        closeArea.style.display = "block";
    }, false);
}
/**
 * すべて選択ボタン
 */
function initAllCheckButton() {
    const form = document.getElementById("userWebinarSearchForm");
    const btns = document.getElementsByClassName("allCheckBtn");
    for (let i = 0; i < btns.length; i++) {
        btns[i].addEventListener("click", function (event) {
            const allBtn = event.target;
            const allChecked = allBtn.checked;
            const targetName = allBtn.dataset.target;
            for (let j = 0; j < form.elements[targetName].length; j++) {
                form.elements[targetName][j].checked = allChecked;
            }
        }, false);
    }
}
/**
 * ... 開ボタン
 */
function initSummaryOpenButton() {
    const btns = document.getElementsByClassName("resultItemSummaryOpen");
    for (let i = 0; i < btns.length; i++) {
        btns[i].addEventListener("click", function (event) {
            const btn = event.target;
            const srcTargetName = btn.dataset.src;
            const dstTargetName = btn.dataset.dst;
            const src = document.getElementById(srcTargetName);
            const dst = document.getElementById(dstTargetName);
            src.style.display = "none";
            dst.style.display = "block";
        }, false);
    }
}
